
export class ContextModalBodyHTMLComponentController {

    static $inject = [ "$scope", "$rootScope", "$element" ];

    html;

    constructor( $scope, $rootScope, $element ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$element = $element;
    }
    
    $onInit() {
        this.setHtml( `${ this.extend.html }` );
    }

    setHtml( html ) {
        this.html = html;
        this.$element.html( this.html );
    }
}

export const ContextModalBodyHTMLComponent = {

    selector: "context-modal-body-html",
    name: "contextModalBodyHtml",

    bindings: {
        extend: "=",
        data:   "=",
    },

    controller: ContextModalBodyHTMLComponentController
};